import { Controller } from "@hotwired/stimulus";
import * as bootstrap from "bootstrap";

export default class extends Controller {
  static targets = ["dropdown"];

  connect() {
    this.closeOnVisit = this.close.bind(this);
    document.addEventListener("turbo:before-visit", this.closeOnVisit);
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this.closeOnVisit);
  }

  close() {
    const instance = bootstrap.Collapse.getInstance(this.dropdownTarget);
    instance?.hide();
  }
}
